// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TimeSpan, TimeSpanFormat } from "../../Utils/Time/TimeSpan.ts";
import { Resources } from "../../Commons/properties/Resources.ts";
import { QuickTableColumnType, QuickTableEditingInfo } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.ts";
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.ts";
import { DynProperty } from "../../Commons/DynProperty.ts";
import { DateTimeConvertor } from "../../Utils/Time/DateTimeConvertor.ts";


export let EventItem = function (ev, settings, dataCache, foreColor, backColor)
{
    BaseItem.call(this, settings);

    // TODO. Ugly. For table init.
    if (!ev) return;

    this.ev = ev;

    this.ItemId = ev.Id;

    this.dataCache = dataCache;
    //this.sessionSettings = settings;

    this.foreColorByPanelColoring = foreColor;
    this.backColorByPanelColoring = backColor;

    this.CustomColoring = true;

    this.QuickTableEditingInfoMap[3] = (function ()
    {
        return new QuickTableEditingInfo(DynProperty.INFO_PICTURE);
    })();

    //TODO normalize
    this.CellForeColorMap[0] = this.foreColorByPanelColoring;
    this.CellForeColorMap[1] = this.foreColorByPanelColoring;
    this.CellForeColorMap[2] = this.foreColorByPanelColoring;
    this.CellForeColorMap[3] = this.foreColorByPanelColoring;
    this.CellForeColorMap[5] = this.foreColorByPanelColoring;
};
EventItem.prototype = Object.create(BaseItem.prototype);

EventItem.prototype.GetColumnParams = function (columnIdx)
{
    let par = EventItem.columnsParams[columnIdx];
    if (Resources.isHidden(par.HeaderKey))
        par.Hidden = true;
    return par;
};

EventItem.prototype.ColumnCount = function ()
{
    return EventItem.columnsParams.length;
};

EventItem.prototype.getColumnData = function (columnIdx)
{
    /* TODO.
    if (column >= columnsParams.Length && customColumnFormattedValues.ContainsKey(column))
    {
        o = customColumnValues[column];
        return customColumnFormattedValues[column];
    }
    */

    let value = this.getColumnValue(columnIdx);
    let formattedValue = null;
    let ev = this.ev;

    switch (columnIdx)
    {
        case 1:
            formattedValue = DateTimeUtils.formatDate(value, 'DD.MM.YYYY  HH:mm:ss.SSS');
            break;

        case 4:
            formattedValue = ev.Roundtrip > 0 ?
                TimeSpan.ToTimeSpanString(ev.Roundtrip, TimeSpanFormat.MilisecondSecondMinute) :
                '';
            break;

        default:
            formattedValue = value.toString();
    }

    return { Value: value, FormattedValue: formattedValue };
};

EventItem.prototype.getColumnValue = function (columnIdx)
{
    /* TODO.
    if (column >= columnsParams.Length && customColumnValues.ContainsKey(column))
        return customColumnValues[column];
    */

    let sessionSettings = this.sessionSettings;
    let dataCache = this.dataCache;
    let ev = this.ev;

    switch (columnIdx)
    {
        case 0:
            return ev.EventTypeStr(sessionSettings.Locale);

        case 1:
            return DateTimeConvertor.ConvertUTCTimeToSelectedTimeZone(ev.DateTime, dataCache);

        case 2:
            let reportLocKey = 'reports.' + ev.Action;
            if (Resources.IsResourcePresent(reportLocKey))
                return Resources.getResource(reportLocKey);
            else
                return Resources.getResource(ev.Action);
        // TODO. Looks like shit.
        // else return Resources.getResource(ev.action.Trim().Replace('\n', ' '), sessionSettings.Locale);

        case 3:
            return ev.GetFormattedDescription();

        case 4:
            return ev.Roundtrip;

        default:
            return '';
    }
};

EventItem.columnsParams = [
    new ColumnParams("panel.EventLog.Type", 100, 0, false, true, true),
    new ColumnParams("panel.EventLog.Date", 100, QuickTableColumnType.COL_DATE_SORT, false, true, false),
    new ColumnParams("panel.EventLog.Action", 100, 0, false, true, true),
    new ColumnParams("panel.EventLog.Message", 50, 0, false, true, false),
    //new ColumnParams("panel.EventLog.Roundtrip", 40, QuickTableColumnType.COL_SIMPLE_NUMERIC, false, true, false),
];